{
  "en": {
    "directUpload": {
      "title": "Upload",
      "chooseFiles": "Choose files",
      "dropzone": {
        "textMultiple": "Drop files here",
        "textDirectory": "Drop a folder here",
        "text": "Drop file here",
        "or": "or",
        "browse": "browse",
        "browseDirectory": "choose a folder"
      },
      "previewImage": {
        "remove": "Remove"
      },
      "actions": {
        "upload": "Upload",
        "close": "Close"
      }
    }
  }
}
